<template>
  <div class="text-window">
    <b-row>
      <b-col sm="3">
        <b-select size="sm" v-model="codeFilter" @change="$emit('changeCodeFilter', $event)" :options="codeTypes"/>
      </b-col>
      <b-col sm="3">
        <!-- <b-select size="sm" v-model="reasonTypeForBarcode" @change="$emit('changeTroubleFilter', $event)" :options="reasonTypes"/> -->
        <b-input v-model="reasonTypeForBarcode" @change="$emit('changeTroubleFilter', $event)" size="sm"/>
      </b-col>
      <b-col sm="3">
        <b-row>
          <b-col sm=6 class="pr0">
            <b-form-input size="sm" v-model="troubleQuantity" @change="$emit('updateTroubleQuantity', $event)" class="pw05"></b-form-input>
          </b-col>
          <b-col sm=3 class="pl025 pr0">
            <b-button size="sm" @click="$emit('upAdditionalCount', $event)" class="btn-100w" variant="danger">+</b-button>
          </b-col>
          <b-col sm=3 class="pl025 pr0">
            <b-button size="sm" @click="$emit('downAdditionalCount', $event)" class="btn-100w" variant="dark">‐</b-button>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="3">
        <!-- <b-button size="sm" :disabled="activeToTrouble === '0' || troubleQuantity === ''" class="ml1" @click="$emit('clickToTroubleTrenai', $event)" variant="danger">管理品登録</b-button> -->
        <b-button size="sm" :disabled="activeToTrouble === '0' || troubleQuantity === '' || locationNumber === ''" class="ml1" @click="$emit('clickToTroubleTrenai', $event)" variant="danger">管理品登録</b-button>
      </b-col>
    </b-row>
    <b-row v-if="reasonCodeStr !== ''">
      <b-col>
        ※問題理由 → {{ reasonCodeStr }}
      </b-col>
    </b-row>
    <b-row v-show="troubleFilter === '12'" class="mt-2">
      <b-col sm="12">
        <b-input-group size="sm" prepend="その他">
          <b-form-input size="sm" v-model="troubleFilterOther" @change="$emit('updateTroubleFilterOther', $event)" class=""></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row v-show="troubleFilter !== '0'" class="mt-2">
      <b-col sm="4">
        <b-input-group size="sm" prepend="会員番号">
          <b-form-input size="sm" v-model="troubleMemberFilter" @change="$emit('updateTroubleMemberFilter', $event)" class=""></b-form-input>
        </b-input-group>
      </b-col>
      <b-col sm="4">
        <b-input-group size="sm" prepend="Location番号">
          <b-form-input size="sm" v-model="locationNumber" @change="$emit('updateLocationNumber', $event)" class=""></b-form-input>
          <!-- <b-form-select size="sm" v-model="locationNumberFilter" :options="locationTypes" @change="$emit('updateLocationNumberFilter', $event)"></b-form-select> -->
        </b-input-group>
      </b-col>
      <b-col sm="4">
        <b-input-group size="sm" prepend="追跡番号">
          <b-form-input size="sm" v-model="trackingFilter" @change="$emit('updateTrackingFilter', $event)" class=""></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>
    <!-- <b-modal ref="confirmMessage" ok-only hide-header>
      <div class="text-center"><label>{{confirmMessage}}</label></div>
    </b-modal> -->
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import CodeType from '@/types/CodeType';
import ReasonType from '@/types/ReasonType';
import LocationType from '@/types/LocationType';

export default {
  mixins: [BaseComponent],
  props: {
    codeFilter: { default: '1' },
    troubleFilter: { default: '0' },
    troubleQuantity: { default: '' },
    activeToTrouble: { default: '1' },
    troubleFilterOther: { default: '' },
    trackingFilter: { default: '' },
    reasonTypeForBarcode: { default: '' },
    reasonCodeStr: { default: '' },
    locationNumber: { default: ''},
    troubleMemberFilter: { default: '' },
  },
  data() {
    return {
      codeTypes: CodeType.filterValues(),
      reasonTypes: ReasonType.values2(),
      locationTypes: LocationType.values(),
      // reasonTypeForBarcode: '',
      confirmMessage: ''
      // reasonCodeStr: ''
    };
  },
  computed: {
  },
  methods: {
    // convertReasonCode(){
    //   var code = '99';
    //   if(this.reasonTypeForBarcode === ''){
    //     return;
    //   } else if(this.reasonTypeForBarcode === '1'){
    //     code = '01';
    //     this.reasonCodeStr = 'SKU登録無し';
    //   } else if(this.reasonTypeForBarcode === '2'){
    //     code = '03';
    //     this.reasonCodeStr = 'ASIN無効';
    //   } else if(this.reasonTypeForBarcode === '3'){
    //     code = '04';
    //     this.reasonCodeStr = 'LAS登録無し';
    //   } else if(this.reasonTypeForBarcode === '4'){
    //     code = '10';
    //     this.reasonCodeStr = '輸出不可';
    //   } else if(this.reasonTypeForBarcode === '5'){
    //     code = '18';
    //     this.reasonCodeStr = '商品にJANがありません';
    //   } else if(this.reasonTypeForBarcode === '6'){
    //     code = '19';
    //     this.reasonCodeStr = '商品JANがスキャン出来ない状態で届きました';
    //   } else if(this.reasonTypeForBarcode === '7'){
    //     code = '20';
    //     this.reasonCodeStr = '行き先わかれ（商品登録時のバーコードタイプ選択ミス）';
    //   } else if(this.reasonTypeForBarcode === '8'){
    //     code = '21';
    //     this.reasonCodeStr = '行き先わかれ（納品先が分かれます納品プランを作成して確認してください）';
    //   } else if(this.reasonTypeForBarcode === '9'){
    //     code = '22';
    //     this.reasonCodeStr = '数量違い';
    //   } else if(this.reasonTypeForBarcode === '10'){
    //     code = '23';
    //     this.reasonCodeStr = 'FBA納品不可になりました。一度セラセンで納品プランを作成してご確認下さい';
    //   } else if(this.reasonTypeForBarcode === '11'){
    //     code = '25';
    //     this.reasonCodeStr = '特殊便以外での発送不可';
    //   } else if(this.reasonTypeForBarcode === '12'){
    //     code = '26';
    //     this.reasonCodeStr = 'バリエーション商品の為';
    //   } else if(this.reasonTypeForBarcode === '13'){
    //     code = '12';
    //     this.reasonCodeStr = 'その他';
    //   }
    //   if(code === '99'){
    //     this.confirmMessage = '想定外の番号が入力されました。';
    //     this.$refs.confirmMessage.show();
    //     this.reasonTypeForBarcode = '';
    //     return;
    //   }
    //   this.$emit('changeTroubleFilter', code);
    // }
  },
};
</script>
<style>
.text-window {
    padding: 1em;
    background-color: lightblue;
}
.pr0{
  padding-right: 0;
}
.pl0{
  padding-left: 0;
}
.pl025{
  padding-left: 0.1rem;
}
.btn-100w{
  height: 100%;
  width: 100%;
}
.pw05{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.ml1{
  margin-left: 1rem;
}
</style>